export default [
  {
    path: '/admin/allowance-claim-missions',
    name: 'allowance-claim-mission',
    meta: { requiresAuth: true },
    component: () => import('@/pages/mission/allowance-claim-mission/index.vue')
  }
]
